export default function Team() {
  
    return (
      <div className='Team'>
        <h3>Radio Megaton Tim</h3>

        <div>
            <p>Anica Plantić</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/direktorica.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Kristina Ljubić</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/kristina-ljubic-1280-770x513.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Darko Foder</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/darko-foder-1280-770x513.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Miroslav Brezovec</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/miroslav-brezovec-1280-770x513.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Miljenka Križnjak</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/miljenka-kriznjak-1280-770x512.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Ljiljana Vuglač</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/ljiljana-vuglac-1280-770x513.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Nikolina Jureković-Novoselec</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/nikolina-jurekovic-novoselec-1280-513x770.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Marlon Janiček</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/marlon-janicek-1280-770x512.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>David Bralo</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/10/david-bralo-1280-770x513.jpg" alt="img"></img>
            <p>Više</p>
        </div>

        <div>
            <p>Tomislav Peček</p>
            <img src="https://radiomegaton.hr/wp-content/uploads/2020/06/tomislav-pecek-1280-770x513.jpg" alt="img"></img>
            <p>Više</p>
        </div>

      </div>
    );
  }